import ApiRequest from "utils/ApiRequest";
import { bulkUploadModel } from "../utils/bulkUploadModel";

export default class EBulletin {
  static getAll = async () => {
    return await ApiRequest.set("v1/e-bulletins/getall", "GET")
  }

  static getById = async (id) => {
    return await ApiRequest.set(`v1/e-bulletins/getbyid/${id}`, "GET")
  }

  static create = async (body) => {
    return await ApiRequest.set("v1/e-bulletins/create", "POST", body)
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/e-bulletins/update/${id}`, "PUT", body)
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/e-bulletins/delete/${id}`, "DELETE")
  }

  static bulkUpload = async (file, dryRun = false) => {
    return await bulkUploadModel('v1/e-bulletins/').bulkUpload(file, dryRun);
  };

  static downloadTemplate = async () => {
    return await bulkUploadModel('v1/e-bulletins/').downloadTemplate();
  };
}